export default __webpack_public_path__ + "static/media/6.77f75b07.jpg";